// Module
var code = "<div class=\"sidebar-cell-content vis-swatch\"> <img alt=\"Icon\" class=\"vis-icon\" src=\"{{icon}}\"/> <div class=\"sidebar-text\" data-test-id=\"visualization-{{name}}\">{{name}}</div> </div> ";
// Exports
export default code;